import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../tooltip';

const Comment = ({ id, comment }) => {
  const maxWords = 4;
  const countWords = str => str.trim().split(/\s+/).length;
  const shortComment = comment
    .split(' ')
    .slice(0, maxWords)
    .join(' ');

  return countWords(comment) > maxWords ? (
    <Tooltip id={id} message={comment} icon="fa-info-circle">
      {`${shortComment}`}
    </Tooltip>
  ) : (
    comment
  );
};

Comment.propTypes = {
  id: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired
};

export default Comment;
